module.exports = __webpack_public_path__ + "img/thumbnail_Platypus_f_normal.e54e04ea.png";